// n차 학습지를 만들기 위해 옵션을 보내면 리턴받는 예상문제 수

import { computed, makeObservable, observable } from 'mobx'

import { MAX_PROBLEM_COUNT } from '@/constant'

import { DTO } from '../DTO'

// 학습지로 n차 학습지를 만들기 위해 옵션을 보내면 리턴받는 값
export class WorksheetDerivationResponse extends DTO implements res.WorksheetDerivation {
  wrongProblemCount = 0 // 총 틀린 문제 수
  wrongProblemConceptSize = 0 // 총 틀린 문제의 개념 수
  conceptIdList: res.Concept['id'][] = [] // 개념들
  problemList: res.Problem<'WORKSHEET'>[] = []
  conceptSize = 0 // 개념 갯수?
  problemIdList: number[] = [] // 문제 id들
  problemSize = 0 // 서버에서 줄 수 있는 오답학습지의 최대 문제수
  wrongCustomSignatureWorkbookProblemCount = 0 // 시그니처 교재 틀린 문제 수
  wrongAcademyGroupWorkbookProblemCount = 0 // 학원그룹 교재 틀린 문제 수
  wrongCustomWorkbookProblemCount = 0 // 커스텀 교재 틀린 문제 수
  wrongCustomWorksheetProblemCount = 0 // 학습지 틀린 문제 수
  wrongPublicWorkbookProblemCount = 0 // 시중교재 틀린 문제 수
  wrongSchoolWorkbookProblemCount = 0 // 교과서 틀린 문제 수
  worksheetLayout = {
    title: '',
    writer: '',
    tag: 'WEAK_WORKSHEET' as common.Tag,
  }

  constructor(data?: Partial<WorksheetDerivationResponse>) {
    super()

    if (data) {
      this.updateExceptNullable(data)
    }

    makeObservable(this, {
      wrongProblemCount: observable,
      wrongProblemConceptSize: observable,
      conceptIdList: observable,
      conceptSize: observable,
      problemIdList: observable,
      problemList: observable,
      problemSize: observable,
      wrongCustomSignatureWorkbookProblemCount: observable,
      wrongAcademyGroupWorkbookProblemCount: observable,
      wrongCustomWorkbookProblemCount: observable,
      wrongCustomWorksheetProblemCount: observable,
      wrongPublicWorkbookProblemCount: observable,
      wrongSchoolWorkbookProblemCount: observable,
      worksheetLayout: observable,
      wrongWorkbookProblemCount: computed,
    })
  }

  // 모든 교재에서 틀린 문제 수
  get wrongWorkbookProblemCount() {
    return (
      this.wrongCustomSignatureWorkbookProblemCount +
      this.wrongAcademyGroupWorkbookProblemCount +
      this.wrongCustomWorkbookProblemCount +
      this.wrongPublicWorkbookProblemCount +
      this.wrongSchoolWorkbookProblemCount
    )
  }

  get enabledCreateRange() {
    return this.problemSize <= MAX_PROBLEM_COUNT && this.problemSize > 0
  }
}
